import * as React from "react"

const BarPressIcon = ({
    width = 12,
    height = 15,
    ...props
}) => (
    <div style={{
        width: width,
        height: height,
        resize: 'both',
    }}>
        <svg
            width={'100%'}
            height={'100%'}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 12 15`}
            {...props}
        >
            <path
                d="M.152 6.56c0-.792.152-1.552.464-2.28a5.755 5.755 0 0 1 1.256-1.864 6.086 6.086 0 0 1 1.872-1.248A5.66 5.66 0 0 1 6.016.704c.792 0 1.552.152 2.28.464.72.312 1.344.728 1.864 1.248s.936 1.144 1.248 1.864c.312.72.464 1.48.464 2.28a5.629 5.629 0 0 1-1.152 3.472 5.798 5.798 0 0 1-2.968 2.088v2.632H4.36v-2.6a5.746 5.746 0 0 1-3.032-2.088A5.643 5.643 0 0 1 .152 6.56Zm1.288 0c0 1.24.448 2.304 1.352 3.192.888.896 1.96 1.344 3.216 1.344.824 0 1.592-.2 2.288-.608a4.609 4.609 0 0 0 1.672-1.656 4.431 4.431 0 0 0 .616-2.28c0-.616-.12-1.2-.36-1.768a4.522 4.522 0 0 0-.976-1.456 4.557 4.557 0 0 0-1.464-.976 4.48 4.48 0 0 0-1.768-.36c-.616 0-1.2.12-1.768.36a4.521 4.521 0 0 0-2.432 2.432A4.294 4.294 0 0 0 1.44 6.56Zm.464.288v-.576H3.64v.576H1.904Zm.872-2.832.416-.416 1.216 1.216-.416.424-1.216-1.224ZM4.8 7.96c0-.336.12-.624.352-.872.232-.248.52-.376.848-.384l2.184-3.592.528.28-1.616 3.864c.144.2.208.432.208.704 0 .352-.12.648-.368.888s-.544.36-.896.36c-.344 0-.64-.12-.88-.36s-.36-.536-.36-.888Zm1.048-3.736V2.496H6.4v1.736h-.552v-.008ZM8.2 6.84v-.592h1.736v.592H8.2Z"
                fill="#fff"
            />
        </svg>
    </div>
)

export default BarPressIcon
